import React, { useState } from 'react';

import Icon from 'components/Icon';

import {
	StyledInput,
	Textarea,
	FieldGroup,
	Label,
	Hint,
	StyledIcon,
	RadioCheckboxWrapper,
	RadioCheckbox,
	RadioLabel,
	CheckboxLabel,
	SelectWrapper,
} from './style';

const Input = ({
	type,
	label,
	value,
	onChange,
	error,
	outline,
	disabled,
	validatorIcon,
	done,
	icon,
	id,
	align,
	name,
	hint,
	ltr,
	checked,
	children,
	autoComplete = 'on',
	placeholder = '',
	onFocus = () => {},
	onBlur = () => {},
	...props
}) => {
	const [hasFocus, setHasFocus] = useState(false);

	if (
		['text', 'email', 'file', 'hidden', 'number', 'tel', 'password'].indexOf(
			type,
		) > -1
	) {
		return (
			<FieldGroup $align={align}>
				<StyledInput
					type={type}
					id={id || name}
					key={id || name}
					name={name}
					value={value || ''}
					$done={done}
					$error={error}
					$outline={outline}
					$hasValue={!!value}
					$hasFocus={hasFocus}
					$ltr={ltr}
					$align={align}
					onFocus={() => {
						onFocus();
						setHasFocus(true);
					}}
					onBlur={() => {
						onBlur();
						setHasFocus(false);
					}}
					onChange={onChange}
					disabled={disabled}
					autoComplete={autoComplete}
					placeholder={placeholder}
					ref={props.innerRef}
					// {...props}
				/>
				<Label
					htmlFor={id || name}
					$done={done}
					$align={align}
					$outline={outline}
				>
					<span>{label}</span>
				</Label>

				{validatorIcon && (error || done) && (
					<StyledIcon $error={error} $done={done} disabled={disabled}>
						<Icon name={error ? 'cross' : 'tick'} />
					</StyledIcon>
				)}

				{((!(validatorIcon && (error || done)) && icon) ||
					(!validatorIcon && icon)) && (
					<StyledIcon
						$error={error}
						$done={done}
						$icon={icon}
						disabled={disabled}
					>
						<Icon name={icon} />
					</StyledIcon>
				)}

				{hint && !error && <Hint $align={align}>{hint}</Hint>}
				{error && (
					<Hint $type='error' $align={align}>
						{error}
					</Hint>
				)}
			</FieldGroup>
		);
	}

	if (type === 'textarea') {
		return (
			<FieldGroup>
				<Textarea
					as='textarea'
					$hasValue={!!value}
					value={value || ''}
					id={id || name}
					key={id || name}
					name={name}
					$ltr={ltr}
					$outline={outline}
					$hasFocus={hasFocus}
					placeholder={placeholder}
					onFocus={() => {
						onFocus();
						setHasFocus(true);
					}}
					onBlur={() => {
						onBlur();
						setHasFocus(false);
					}}
					onChange={onChange}
					{...props}
				/>
				<Label htmlFor={id || name} $done={done}>
					<span>{label}</span>
				</Label>

				{validatorIcon && (error || done) && (
					<StyledIcon $error={error} $done={done} disabled={disabled}>
						<Icon name={error ? 'cross' : 'tick'} />
					</StyledIcon>
				)}

				{((!(validatorIcon && (error || done)) && icon) ||
					(!validatorIcon && icon)) && (
					<StyledIcon
						$error={error}
						$done={done}
						$icon={icon}
						disabled={disabled}
					>
						<Icon name={icon} />
					</StyledIcon>
				)}

				{hint && !error && <Hint>{hint}</Hint>}
				{error && <Hint $type='error'>{error}</Hint>}
			</FieldGroup>
		);
	}

	if (type === 'radio') {
		return (
			<RadioCheckboxWrapper>
				<RadioCheckbox
					readOnly
					type='radio'
					value={value || ''}
					name={name}
					checked={checked}
				/>
				<RadioLabel htmlFor={id || name} onClick={() => onChange(value)}>
					<span />
					{label}
				</RadioLabel>
			</RadioCheckboxWrapper>
		);
	}

	if (type === 'checkbox') {
		return (
			<RadioCheckboxWrapper>
				<RadioCheckbox
					readOnly
					type='checkbox'
					value={value || ''}
					name={name}
					checked={checked}
				/>
				<CheckboxLabel htmlFor={id || name} onClick={() => onChange(value)}>
					<span />
					{label}
				</CheckboxLabel>
			</RadioCheckboxWrapper>
		);
	}

	if (type === 'select') {
		return (
			<SelectWrapper>
				<StyledInput
					as='select'
					onChange={onChange}
					id={id || name}
					key={id || name}
					name={name}
					value={value}
					$outline={outline}
				>
					{children}
				</StyledInput>
				<Icon name='angle-down' />
			</SelectWrapper>
		);
	}

	return null;
};

export default Input;
